import { AuthShell } from './AuthShell';
import { TwoFactorSetup } from './TwoFactorSetup';
import type { AdminUser } from '../../core/types/adminRequests';
type Props = {
  user: AdminUser;
  onDone: (user: AdminUser) => void;
  onSkip: () => void;
  onLogout: () => void;
};

/**
 * Direct na het inloggen, zolang 2FA nog uit staat. Mag de server overslaan toestaan
 * (`required: false`), dan staat "Overslaan" erbij; anders kom je hier niet langs.
 */
export function TwoFactorGate({
  user,
  onDone,
  onSkip,
  onLogout
}: Props) {
  return <AuthShell wide data-id="element-4034" data-mp="3czr2u8rsgfbp">
      <div className="mt-10" data-id="element-4035" data-mp="3d1bv1rqmrm6e">
        <TwoFactorSetup user={user} onDone={onDone} onSkip={user.twoFactor.required ? undefined : onSkip} data-id="element-4036" data-mp="3d23q91gbfhw5" />
      </div>
      {user.twoFactor.required && <button type="button" onClick={onLogout} className="mt-6 block py-2 text-[13px] text-muted hover:text-ink" data-id="element-4037" data-mp="33968ixj5dwyl">
          Uitloggen
        </button>}
    </AuthShell>;
}